import numeral from 'numeral';
import { formatMoney } from './stringUtils';

export const formatRewardAmount = (rewardAmount: any, includeDecimal = false) => {
  if (rewardAmount?.rewardAmountType === 'percent') {
    return numeral(rewardAmount?.rewardPercent / 100.0).format(`0,0%`);
  }
  return formatMoney(rewardAmount?.rewardAmount, '$', includeDecimal);
};

export const getBrandIds = (brandEntity: Record<string, unknown> | undefined) => {
  if (brandEntity?.brandIds && Array.isArray(brandEntity.brandIds) && brandEntity.brandIds.length > 0) {
    return brandEntity.brandIds;
  }
  if (brandEntity?.brandId != null) {
    return [brandEntity.brandId];
  }
  return undefined;
};
